import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { settingsAPI } from '../lib/api';

const SiteContext = createContext(null);

const defaultSettings = {
  site_name: 'ভূমি',
  site_tagline: 'ভূমির সব সমস্যা এক জায়গায়',
  contact_email: 'info@bhumi.bd',
  contact_phone: '+৮৮০ ১৭XX-XXXXXX',
  contact_address: 'ঢাকা, বাংলাদেশ',
  whatsapp_default_message: 'আসসালামু আলাইকুম, ভূমি প্ল্যাটফর্ম থেকে আপনার সাথে যোগাযোগ করছি।',
};

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await settingsAPI.getPublic();
        setSettings(prev => ({ ...prev, ...res.data }));
      } catch (err) {
        console.error('Failed to load site settings:', err);
      }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  const refreshSettings = useCallback(async () => {
    try {
      const res = await settingsAPI.getPublic();
      setSettings(prev => ({ ...prev, ...res.data }));
    } catch (err) {
      console.error('Failed to refresh settings:', err);
    }
  }, []);

  const value = useMemo(() => ({
    settings, loading, refreshSettings
  }), [settings, loading, refreshSettings]);

  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within SiteProvider');
  }
  return context;
};
